export default __webpack_public_path__ + "static/after-support-thumbnail-second-38fbbb1d209eaa13e7c2edf95fb3afa0.avif";